import { http } from '../index'

// ==================== 类型定义 ====================

// 节点类型
export type NodeType = 'start' | 'end' | 'approval' | 'condition' | 'cc' | 'trigger'

// 审批人类型
export type ApproverType = 'user' | 'role' | 'department' | 'custom'

// 审批方式
export type ApprovalMode = 'sequential' | 'parallel' | 'any'

// 条件类型
export type ConditionType = 'field' | 'formula' | 'custom'

// 节点配置
export interface WorkflowNode {
  id: string
  type: NodeType
  name: string
  x: number
  y: number
  properties?: {
    // 审批节点配置
    approverType?: ApproverType
    approverMode?: ApprovalMode
    approvers?: Array<{
      id: number
      name: string
      type: ApproverType
    }>
    // 条件节点配置
    conditions?: Array<{
      field: string
      operator: string
      value: any
    }>
    // 抄送节点配置
    ccUsers?: Array<{
      id: number
      name: string
    }>
    // 其他配置
    description?: string
    timeout?: number // 超时时间（小时）
    autoPass?: boolean // 超时自动通过
  }
}

// 连线配置
export interface WorkflowEdge {
  id: string
  sourceNodeId: string
  targetNodeId: string
  type?: string
  properties?: {
    condition?: string
    label?: string
  }
}

// 审批流定义
export interface Workflow {
  id: number
  name: string
  code: string
  description?: string
  category?: string
  icon?: string
  nodes: WorkflowNode[]
  edges: WorkflowEdge[]
  status: number // 0草稿,1启用,2停用
  version: number
  is_default?: boolean
  created_at?: string
  updated_at?: string
  creator?: {
    id: number
    name: string
  }
}

// 审批流列表查询参数
export interface WorkflowListParams {
  page?: number
  per_page?: number
  keyword?: string
  category?: string
  status?: number
}

// 创建审批流数据
export interface WorkflowCreateData {
  name: string
  code?: string
  description?: string
  category?: string
  icon?: string
  nodes: WorkflowNode[]
  edges: WorkflowEdge[]
  status?: number
}

// 更新审批流数据
export interface WorkflowUpdateData extends Partial<WorkflowCreateData> {}

// 审批流实例
export interface WorkflowInstance {
  id: number
  workflow_id: number
  workflow_name: string
  business_id: number
  business_type: string
  current_node_id: string
  status: number // 0进行中,1已通过,2已驳回,3已撤销
  created_at: string
  updated_at: string
  applicant?: {
    id: number
    name: string
  }
}

// 审批记录
export interface ApprovalRecord {
  id: number
  instance_id: number
  node_id: string
  node_name: string
  approver_id: number
  approver_name: string
  action: number // 1通过,2驳回,3转交
  comment?: string
  created_at: string
}

// ==================== API 接口 ====================

export const workflowApi = {
  // 获取审批流列表
  list: (params: WorkflowListParams = {}) => {
    return http.get<{ data: Workflow[], total: number }>('/admin/workflows', { params })
  },

  // 获取审批流详情
  detail: (id: number) => {
    return http.get<Workflow>(`/admin/workflows/${id}`)
  },

  // 创建审批流
  create: (data: WorkflowCreateData) => {
    return http.post<Workflow>('/admin/workflows', data)
  },

  // 更新审批流
  update: (id: number, data: WorkflowUpdateData) => {
    return http.put<Workflow>(`/admin/workflows/${id}`, data)
  },

  // 删除审批流
  delete: (id: number) => {
    return http.delete(`/admin/workflows/${id}`)
  },
}

export default workflowApi
